import useNetwork from './network';
import { IOrganizationModel } from './models/organizationModel';
import { IErrorModel } from './models/errorModel';

export const createOrganization = async (lang: string, id: string, details: IOrganizationModel) => {
    const { createOrganization } = useNetwork();
    const result = await createOrganization(lang, id, details);

    if (result.status === 201) {
        return (await result.json()) as IOrganizationModel;
    }
};

export const updateOrganization = async (lang: string, id: string, details: IOrganizationModel) => {
    const { updateOrganization } = useNetwork();
    if (!details.ownershipChangeDate) {
        delete details.ownershipChangeDate;
    }

    if (!details.legalNameChangeDate) {
        delete details.legalNameChangeDate;
    }

    const result = await updateOrganization(lang, id, details);

    if (result.status === 200) {
        return (await result.json()) as IOrganizationModel;
    } else {
        return (await result.json()) as IErrorModel;
    }
};

export const deleteOrganization = async (lang: string, id: string) => {
    const { deleteOrganization } = useNetwork();
    const result = await deleteOrganization(lang, id);

    if (result.status === 200) {
        return (await result.json()) as IOrganizationModel;
    }
};
